import React, { useEffect, useState } from "react"
import Navbar from "../../components/navbar/Navbar"
import "./index.scss"
import { getCookiesConfigObject, getFooterConfigObject, getMenuConfigObject } from "../../utils/graphqlUtils"
import { graphql } from "gatsby"
import { ImageHeader } from "../../components/imageHeader"
import { RichText } from "prismic-reactjs"
import { AppButton } from "../../components/button"
import { Footer } from "../../components/footer/Footer"
import desktopDelimiter from "../../images/delimiter_desktop.png"
import logo from "../../images/heidi-logo.png"
import mountains from "../../images/mountains.png"
import { Divider } from "../../components/divider"
import TemplateWrapper from "../../components/layout"

export const CareerDetails = ({ data, pageContext, ...props }) => {

  const getTemplateData = data && data.prismic && data.prismic.allCareer_details_pages && data.prismic.allCareer_details_pages.edges && data.prismic.allCareer_details_pages.edges[0] && data.prismic.allCareer_details_pages.edges[0].node
  const getCareerDetails = data && data.prismic && data.prismic.allOpen_career_positions && data.prismic.allOpen_career_positions.edges && data.prismic.allOpen_career_positions.edges[0] && data.prismic.allOpen_career_positions.edges[0].node

  // console.log("template", getTemplateData)
  // console.log("data", data)
  // console.log("career", getCareerDetails)

  useEffect(() => {
  }, [])

  return (
    <TemplateWrapper>
      <div id="career-details">
        <Navbar {...props} menuObject={getMenuConfigObject(data)} data={data} pageContext={pageContext}/>
        {/*<div className="app-navbar-placeholder"/>*/}
        <div>
          <div className="d-block d-sm-none">
            <ImageHeader imgSrc={getTemplateData.header_image?.url}/>
            <div className="container text-center">
              {getTemplateData && getTemplateData.page_title && getTemplateData.page_title[0] &&
              <div>
                <img className="img-fluid" src={logo} width="75"/>
                {RichText.render(getTemplateData.page_title)}
              </div>
              }
              {getTemplateData.page_description && getTemplateData.page_description[0] &&
              <div>
                {RichText.render(getTemplateData.page_description)}
              </div>
              }
              {/*{getCareerDetails && getCareerDetails.job_title && getCareerDetails.job_title[0] &&*/}
              {/*<div>*/}
              {/*  {RichText.render(getCareerDetails.job_title)}*/}
              {/*  {getCareerDetails && getCareerDetails.location && getCareerDetails.location.location_name &&*/}
              {/*  <div className="career-location">{getCareerDetails.location.location_name}</div>*/}
              {/*  }*/}
              {/*</div>*/}
              {/*}*/}
              {/*{getCareerDetails && getCareerDetails.job_long_description && getCareerDetails.job_long_description[0] &&*/}
              {/*<div className="py-4">{RichText.render(getCareerDetails.job_long_description)}</div>*/}
              {/*}*/}
              {getTemplateData.main_section_title && getTemplateData.main_section_title[0] &&
              <div id="open-positions">
                <Divider/>
                <img className="img-fluid" src={mountains} width="100"/>
                {RichText.render(getTemplateData.main_section_title)}
                <Divider/>
              </div>
              }
            </div>
          </div>
          <div className="d-none d-sm-block">
            <section className="container-fluid p-0">
              <div className="row m-0">
                <div className="page-container d-flex position-relative">
                  <div className="desktop-left-section"
                       style={{ backgroundImage: `url('${getTemplateData.header_image?.url}')` }}>
                    <div className="desktop-section-delimiter"
                         style={{ backgroundImage: `url('${desktopDelimiter}')` }}/>
                  </div>
                  <div className="desktop-right-section d-flex flex-column align-items-center justify-content-center"/>
                  <div className="container position-absolute desktop-right-container p-0">
                    <div className="row justify-content-end">
                      <div className="col-6 p-0 text-center">
                        <div className="my-3">
                          <img className="img-fluid my-3" src={logo} width="75"/>
                          {getTemplateData && getTemplateData.page_title && getTemplateData.page_title[0] &&
                          <div>
                            {RichText.render(getTemplateData.page_title)}
                          </div>
                          }
                          {getTemplateData && getTemplateData.page_description && getTemplateData.page_description[0] &&
                          <div className="career-location">{RichText.render(getTemplateData.page_description)}</div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <div className="container text-center">
            <div className="d-none d-sm-block">
              <img className="img-fluid mt-5 mb-3" src={mountains} width="100"/>
              {getTemplateData && getTemplateData.main_section_title && getTemplateData.main_section_title[0] &&
              <div>{RichText.render(getTemplateData.main_section_title)}</div>
              }
              <Divider/>
            </div>
            {getCareerDetails && getCareerDetails.job_title && getCareerDetails.job_title[0] &&
            <div className="py-sm-5">
              {RichText.render(getCareerDetails.job_title)}
              {getCareerDetails && getCareerDetails.location && getCareerDetails.location.location_name &&
              <div className="career-location">{getCareerDetails.location.location_name}</div>
              }
            </div>
            }
            {getCareerDetails && getCareerDetails.job_long_description && getCareerDetails.job_long_description[0] &&
            <div className="py-4">{RichText.render(getCareerDetails.job_long_description)}</div>
            }
            {/*<img className="img-fluid d-none d-sm-block my-4" src={mountains} width="100" style={{ margin: "auto" }}/>*/}
            {getCareerDetails && getCareerDetails.responsibilities_title && getCareerDetails.responsibilities_title[0] &&
            <div>{RichText.render(getCareerDetails.responsibilities_title)}</div>
            }
            {getCareerDetails && getCareerDetails.responsibilities_description && getCareerDetails.responsibilities_description[0] &&
            <div className="py-4">{RichText.render(getCareerDetails.responsibilities_description)}</div>
            }
            {getCareerDetails && getCareerDetails.requirements_title && getCareerDetails.requirements_title[0] &&
            <div>{RichText.render(getCareerDetails.requirements_title)}</div>
            }
            {getCareerDetails && getCareerDetails.requirements_description && getCareerDetails.requirements_description[0] &&
            <div className="py-4">{RichText.render(getCareerDetails.requirements_description)}</div>
            }
            {getCareerDetails && getCareerDetails.benefits_title && getCareerDetails.benefits_title[0] &&
            <div>{RichText.render(getCareerDetails.benefits_title)}</div>
            }
            {getCareerDetails && getCareerDetails.benefits_description && getCareerDetails.benefits_description[0] &&
            <div className="pt-4 pb-0 pb-sm-0 pt-sm-4">{RichText.render(getCareerDetails.benefits_description)}</div>
            }
            <div className="my-sm-5 py-sm-5">
              {getCareerDetails && getCareerDetails.upload_cv_button_link && getCareerDetails.upload_cv_button_text &&
              // <form className="upload-cv-form" action={`mailto:${getCareerDetails.upload_cv_button_link}`} method="post" enctype="multipart/form-data">
              //   <input type="file" id="upload-cv" className="custom-file-input"/>
              //   <label htmlFor="upload-cv">{getCareerDetails.upload_cv_button_text}</label>
              //   <input type="submit" name="submit" />
              // </form>
              <a className="mail-to-button" href={`mailto:${getCareerDetails.upload_cv_button_link}`}>{getCareerDetails.upload_cv_button_text}</a>
              }
              {getCareerDetails && getCareerDetails.linkedin_link && getCareerDetails.linkedin_link.url && getCareerDetails.apply_on_linkedin_button_text &&
              // <div>
              <AppButton target="_blank" className="linkedin-button" href={getCareerDetails.linkedin_link.url} pageContext={pageContext}>
                {getCareerDetails.apply_on_linkedin_button_text}
              </AppButton>
                // </div>
              }
            </div>
          </div>
        </div>
        <Footer data={getFooterConfigObject(data)}/>
      </div>
    </TemplateWrapper>)
}

export default CareerDetails

export const pageQuery = graphql`
    query OpenCareerPositionQuery($lang: String, $uid: String) {
        prismic {
            allCareer_details_pages(lang: $lang) {
                edges {
                    node {
                        header_image
                        page_title
                        page_description
                        main_section_title
                    }
                }
            }
            allFooter_privacy_policy_linkss(lang: $lang) {
                edges {
                    node {
                        footer_privacy_policy_links {
                            link_title
                            link_resource {
                                ... on PRISMIC__FileLink {
                                    _linkType
                                    url
                                }
                            }
                        }
                    }
                }
            }
            allOpen_career_positions(lang: $lang, uid: $uid) {
                edges {
                    node {
                        _meta {
                            uid
                            lang
                            lastPublicationDate
                        }
                        disabled
                        department {
                            ... on PRISMIC_Job_department {
                                name
                            }
                        }
                        location {
                            ... on PRISMIC_Job_location {
                                location_name
                            }
                        }
                        team {
                            ... on PRISMIC_Job_team {
                                team_name
                            }
                        }
                        job_title
                        job_short_description
                        job_long_description
                        responsibilities_title
                        responsibilities_description
                        requirements_title
                        requirements_description
                        benefits_title
                        benefits_description
                        upload_cv_button_link
                        upload_cv_button_text
                        apply_on_linkedin_button_text
                        linkedin_link {
                            ... on PRISMIC__ExternalLink {
                                _linkType
                                url
                            }
                        }
                    }
                }
            }
            allMenus(lang: $lang) {
                edges {
                    node {
                        what_makes_heidi_unique_label
                        what_makes_heidi_unique_disabled
                        promo_campaign_label
                        promo_campaign_disabled
                        products_label
                        products_disabled
                        online_shop_label
                        online_shop_disabled
                        contact_disabled
                        chocolate_lover_disabled
                        contact_label
                        chocolate_lover_label
                        chocolate_label
                        chocolate_disabled
                        careers_label
                        careers_disabled
                        shops_page_label
                        shops_page_disabled
                    }
                }
            }
            allCookie_consents(lang: $lang) {
                edges {
                    node {
                        cookie_consent_text
                        cookie_consent_link {
                            ... on PRISMIC__ExternalLink {
                                url
                            }
                        }
                        cookie_consent_link_text
                        cookie_consent_button_text
                    }
                }
            }
        }
    }
`
